/**
 * Correspondence Exports — directApiClient (LF-3216)
 *
 * `revalidatePath` dropped — invalidation now happens via React Query at
 * the hook layer (see hooks.tsx).
 */

'use client';

import { directApiClient, DirectApiError } from '@/lib/api/direct-client';
import {
  CreateCorrespondenceExportResponse,
  CorrespondenceExportStatusResponse,
  ListCorrespondenceExportsResponse,
  CorrespondenceExportActionResult
} from './types';

function toErrorResult<T>(error: unknown): CorrespondenceExportActionResult<T> {
  if (error instanceof DirectApiError) {
    return { success: false, error: error.message };
  }
  return {
    success: false,
    error: error instanceof Error ? error.message : 'Request failed'
  };
}

export async function createCorrespondenceExportAction(
  matterId: number,
  correspondenceId: number
): Promise<
  CorrespondenceExportActionResult<CreateCorrespondenceExportResponse>
> {
  try {
    const response =
      await directApiClient.post<CreateCorrespondenceExportResponse>(
        `/matters/${matterId}/correspondences/${correspondenceId}/exports`,
        {}
      );

    return { success: true, data: response };
  } catch (error) {
    return toErrorResult<CreateCorrespondenceExportResponse>(error);
  }
}

export async function getCorrespondenceExportStatusAction(
  matterId: number,
  correspondenceId: number,
  exportId: number
): Promise<
  CorrespondenceExportActionResult<CorrespondenceExportStatusResponse>
> {
  try {
    const response =
      await directApiClient.get<CorrespondenceExportStatusResponse>(
        `/matters/${matterId}/correspondences/${correspondenceId}/exports/${exportId}`
      );
    return { success: true, data: response };
  } catch (error) {
    return toErrorResult<CorrespondenceExportStatusResponse>(error);
  }
}

export async function listCorrespondenceExportsAction(
  matterId: number,
  correspondenceId: number
): Promise<
  CorrespondenceExportActionResult<ListCorrespondenceExportsResponse>
> {
  try {
    const response =
      await directApiClient.get<ListCorrespondenceExportsResponse>(
        `/matters/${matterId}/correspondences/${correspondenceId}/exports`
      );
    return { success: true, data: response };
  } catch (error) {
    return toErrorResult<ListCorrespondenceExportsResponse>(error);
  }
}
